import * as React from "react";
import styled from "styled-components";
import defaultTheme from "../defaultTheme";
import { StyledButtonLink } from "../ButtonLink";
import { StyledButton } from "../Button";
import { borderRadius, rtlSpacing } from "../utils/rtl";
var StyledButtonGroup = styled.div.withConfig({
  displayName: "ButtonGroup__StyledButtonGroup",
  componentId: "sc-82hrp5-0"
})(["display:flex;", ",", "{border-radius:0;margin:", ";:first-child{border-radius:", ";}:last-child{border-radius:", ";margin:0;}}"], StyledButtonLink, StyledButton, function (_ref) {
  var theme = _ref.theme;
  return rtlSpacing(theme.orbit.marginButtonGroup);
}, function (_ref2) {
  var theme = _ref2.theme;
  return borderRadius("".concat(theme.orbit.borderRadiusNormal, " 0 0 ").concat(theme.orbit.borderRadiusNormal));
}, function (_ref3) {
  var theme = _ref3.theme;
  return borderRadius("0 ".concat(theme.orbit.borderRadiusNormal, " ").concat(theme.orbit.borderRadiusNormal, " 0"));
});
StyledButtonGroup.defaultProps = {
  theme: defaultTheme
};

var ButtonGroup = function ButtonGroup(_ref4) {
  var children = _ref4.children,
      dataTest = _ref4.dataTest;
  return React.createElement(StyledButtonGroup, {
    "data-test": dataTest
  }, children);
};

export default ButtonGroup;